import { ReferentialKey } from 'api/referential';
import { selectReferentialByKey } from 'features/referentials/selectors/selectReferentialByKey';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { BaseFormField } from 'types/form/baseFormField';
import { TagInputItem } from 'components/forms/TagInput';
import { FormikTagInput } from 'components/forms/formik/FormikTagInput';

interface ReferentialTagInputProps extends BaseFormField {
  placeholder?: string;
  referentialKey: ReferentialKey;
  disabled?: boolean;
  selectedItemKeys?: (string | number)[];
  omitKeys?: (string | number)[];
  includeKeys?: (string | number)[];
  onChange?: (selectedItems: TagInputItem[]) => void;
  maxTags?: number;
}

export const ReferentialTagInput: FC<ReferentialTagInputProps> = ({
  name,
  label,
  referentialKey,
  disabled,
  required,
  placeholder,
  selectedItemKeys,
  onChange,
  omitKeys,
  includeKeys,
  maxTags
}) => {
  const referential = useSelector(selectReferentialByKey(referentialKey));
  const items = referential && referential.length > 0 ? referential : [];

  return (
    <FormikTagInput
      name={name}
      label={label}
      items={items}
      disabled={disabled}
      placeholder={placeholder}
      required={required}
      omitKeys={omitKeys}
      includeKeys={includeKeys}
      selectedItemKeys={selectedItemKeys}
      onChange={onChange}
      maxTags={maxTags}
    />
  );
};
